export const dayOfWeekValues = [0, 1, 2, 3, 4, 5, 6] as const;
export type DayOfWeek = (typeof dayOfWeekValues)[number];

export interface EmployeeScheduleRuleDto {
  id: string;
  companyId: string;
  employeeId: string;
  effectiveFrom: string; // ISO date (YYYY-MM-DD)
  effectiveTo: string | null; // ISO date (YYYY-MM-DD)
  dayOfWeek: DayOfWeek;
  startLocalTime: string; // HH:mm
  endLocalTime: string; // HH:mm
  createdAt: string;
  updatedAt: string;
}

export interface ListEmployeeSchedulesRequest {
  companyId: string;
  employeeId: string;
}

export interface ListEmployeeSchedulesResponse {
  items: EmployeeScheduleRuleDto[];
}

export interface ListMySchedulesRequest {
  companyId: string;
}

export interface ListMySchedulesResponse {
  items: EmployeeScheduleRuleDto[];
}

export interface CreateEmployeeScheduleRequest {
  companyId: string;
  employeeId: string;
  effectiveFrom: string; // ISO date (YYYY-MM-DD)
  effectiveTo?: string | null; // ISO date (YYYY-MM-DD)
  dayOfWeek: DayOfWeek;
  startLocalTime: string; // HH:mm
  endLocalTime: string; // HH:mm
}

export interface CreateEmployeeScheduleResponse {
  schedule: EmployeeScheduleRuleDto;
}

export interface UpdateEmployeeScheduleRequest {
  companyId: string;
  employeeId: string;
  scheduleId: string;
  effectiveFrom?: string; // ISO date (YYYY-MM-DD)
  effectiveTo?: string | null; // ISO date (YYYY-MM-DD)
  dayOfWeek?: DayOfWeek;
  startLocalTime?: string; // HH:mm
  endLocalTime?: string; // HH:mm
}

export interface UpdateEmployeeScheduleResponse {
  schedule: EmployeeScheduleRuleDto;
}

export interface DeleteEmployeeScheduleRequest {
  companyId: string;
  employeeId: string;
  scheduleId: string;
}

export interface DeleteEmployeeScheduleResponse {
  scheduleId: string;
}
